// Auto-generated from Master Promotional Grid All Accounts.xlsx

export function getWeekDate(w){
  const s=new Date("2025-07-02");
  s.setDate(s.getDate()+(w-1)*7);
  return s.toLocaleDateString("en-AU",{day:"numeric",month:"short"});
}

export const MAJANS_KEY_DATES = {
  "16": "Diwali 15/10/24",
  "40": "Easter Week"
};

// ── Coles campaigns (spanning periods) ──────────────────────────────────────
export const COLES_KEY_DATES = {
  "37": "DOWN DOWN AUTUMN",
  "49": "DOWN DOWN WINTER"
};

export const COLES_CAMPAIGNS = [
  { startWeek: 37, endWeek: 48, label: "DOWN DOWN AUTUMN" },
  { startWeek: 49, endWeek: 52, label: "DOWN DOWN WINTER" },
];

// ── WW key dates (point-in-time events — for header colouring & events row) ──
export const WW_KEY_DATES = {
  "1":  "NAIDOC WEEK 6/7–13/7",
  "2":  "State Of Origin G3 9/7 | BTS NSW/VIC/SA/WA",
  "10": "Father's Day 7/9",
  "11": "RU OK Day 11/9",
  "13": "AFL GF Eve 27/9 & GF 28/9",
  "14": "Labour Day (NSW/ACT/SA) | King's Birthday QLD | NRL GF 5/10",
  "16": "Diwali 20/10",
  "18": "Melbourne Cup 4/11 | Halloween 31/10",
  "19": "Singles Day 11/11 | Nat'l Recycling Week | Remembrance Day",
  "26": "Xmas Eve 24/12 · Xmas Day 25/12 · Boxing Day 26/12",
  "27": "Boost Your Budget | NYE 31/12",
  "28": "BTS Multipack Chips | Australia Day | Healthier NY",
  "31": "Lunar New Year | BTS",
  "34": "NPD Activation | Lent / Easter Entertaining | Holi 4/3",
  "36": "Coeliac Awareness Week",
  "39": "Orthodox Easter",
  "41": "Back To School",
  "44": "Mother's Day",
  "45": "Dragon Boat Festival",
  "48": "Eid al Adha",
  "51": "YET TO LOAD",
};

// ── WW season campaigns (spanning, non-overlapping) ──────────────────────────
export const WW_CAMPAIGNS = [
  { startWeek:  9, endWeek: 20, label: "LOW PRICES FOR SPRING" },
  { startWeek: 21, endWeek: 37, label: "LOW PRICES FOR SUMMER" },
  { startWeek: 38, endWeek: 49, label: "LOW PRICES FOR AUTUMN" },
  { startWeek: 50, endWeek: 52, label: "LOW PRICES FOR WINTER" },
];

// ── WW seasonal promo periods (spanning, non-overlapping within this row) ────
export const WW_SEASONAL_SPANS = [
  { startWeek: 13, endWeek: 19, label: "DIWALI PROMO PERIOD",  dates: "wc 24/9–10/11/25" },
  { startWeek: 24, endWeek: 27, label: "XMAS PROMO BLOCK",     dates: "wc 10/12–7/1" },
  { startWeek: 35, endWeek: 38, label: "Ramadan",              dates: "28/2–29/3/26" },
  { startWeek: 39, endWeek: 41, label: "Easter / Passover",    dates: "1–9/4/26" },
  { startWeek: 46, endWeek: 47, label: "BIG NIGHT IN",         dates: "wc 13–26/5/26" },
];

// ── School terms (spanning format) ──────────────────────────────────────────
export const SCHOOL_TERMS_SPANS = {
  "ACT": [
    { startWeek:  3, endWeek: 13, label: "TERM 3", dates: "21/7–25/9/25" },
    { startWeek: 15, endWeek: 25, label: "TERM 4", dates: "13/10–18/12/25" },
    { startWeek: 31, endWeek: 40, label: "TERM 1", dates: "30/1–2/4/26" },
    { startWeek: 42, endWeek: 52, label: "TERM 2", dates: "21/4–3/7/26" },
  ],
  "NSW": [
    { startWeek:  3, endWeek: 13, label: "TERM 3", dates: "22/7–26/9/25" },
    { startWeek: 15, endWeek: 25, label: "TERM 4", dates: "14/10–19/12/25" },
    { startWeek: 30, endWeek: 40, label: "TERM 1", dates: "27/1–2/4/26" },
    { startWeek: 42, endWeek: 52, label: "TERM 2", dates: "20/4–3/7/26" },
  ],
  "NT": [
    { startWeek:  2, endWeek: 12, label: "TERM 3", dates: "14/7–19/9/25" },
    { startWeek: 14, endWeek: 24, label: "TERM 4", dates: "6/10–12/12/25" },
    { startWeek: 31, endWeek: 40, label: "TERM 1", dates: "28/1–2/4/26" },
    { startWeek: 41, endWeek: 51, label: "TERM 2", dates: "13/4–19/6/26" },
  ],
  "QLD": [
    { startWeek:  2, endWeek: 12, label: "TERM 3", dates: "14/7–19/9/25" },
    { startWeek: 14, endWeek: 24, label: "TERM 4", dates: "7/10–12/12/25" },
    { startWeek: 30, endWeek: 40, label: "TERM 1", dates: "27/1–2/4/26" },
    { startWeek: 42, endWeek: 52, label: "TERM 2", dates: "20/4–26/6/26" },
  ],
  "SA": [
    { startWeek:  3, endWeek: 13, label: "TERM 3", dates: "21/7–26/9/25" },
    { startWeek: 15, endWeek: 24, label: "TERM 4", dates: "13/10–12/12/25" },
    { startWeek: 30, endWeek: 41, label: "TERM 1", dates: "27/1–10/4/26" },
    { startWeek: 43, endWeek: 52, label: "TERM 2", dates: "27/4–3/7/26" },
  ],
  "TAS": [
    { startWeek:  3, endWeek: 13, label: "TERM 3", dates: "21/7–26/9/25" },
    { startWeek: 15, endWeek: 25, label: "TERM 4", dates: "13/10–18/12/25" },
    { startWeek: 32, endWeek: 42, label: "TERM 1", dates: "5/2–17/4/26" },
    { startWeek: 44, endWeek: 52, label: "TERM 2", dates: "4/5–10/7/26" },
  ],
  "VIC": [
    { startWeek:  3, endWeek: 12, label: "TERM 3", dates: "21/7–19/9/25" },
    { startWeek: 14, endWeek: 25, label: "TERM 4", dates: "6/10–19/12/25" },
    { startWeek: 30, endWeek: 40, label: "TERM 1", dates: "27/1–2/4/26" },
    { startWeek: 42, endWeek: 52, label: "TERM 2", dates: "20/4–26/6/26" },
  ],
  "WA": [
    { startWeek:  3, endWeek: 13, label: "TERM 3", dates: "21/7–26/9/25" },
    { startWeek: 15, endWeek: 25, label: "TERM 4", dates: "13/10–18/12/25" },
    { startWeek: 31, endWeek: 40, label: "TERM 1", dates: "2/2–2/4/26" },
    { startWeek: 42, endWeek: 52, label: "TERM 2", dates: "20/4–3/7/26" },
  ],
};

// Keep legacy SCHOOL_TERMS for any other consumers
export const SCHOOL_TERMS = {};

export const WW_FY26_PROMOS = [
  {
    "assortment": "Bhuja 70-160g & Authentic Indian 70-150g",
    "brand": "Bhuja",
    "data": {
      "PROMO PRICE": {
        "1": "2.95",
        "4": "50% OFF",
        "5": "4 FOR $10 ONLINE",
        "8": "50% OFF",
        "12": "2.95",
        "13": "2 FOR $7",
        "14": "2.95",
        "15": "2 FOR $7",
        "16": "50% OFF",
        "17": "2 FOR $7",
        "18": "2.95",
        "19": "50% DESI ONLY",
        "20": "50% DESI ONLY",
        "21": "4 FOR $10 ONLINE",
        "22": "4 FOR $10 ONLINE",
        "23": "2.95",
        "25": "2.95",
        "26": "2.95",
        "29": "2.95",
        "31": "50% OFF",
        "33": "2.95",
        "34": "2 FOR $7",
        "35": "50% OFF",
        "36": "2 FOR $7",
        "37": "2.95",
        "40": "50% OFF",
        "41": "2 FOR $7",
        "42": "2.95",
        "44": "2.95",
        "45": "3 FOR $9",
        "47": "50% OFF",
        "48": "2 FOR $7",
        "49": "2 FOR $7",
        "50": "50% OFF",
        "51": "2 FOR $7",
        "52": "50% OFF"
      },
      "PROMO/MEDIA": {
        "4": "CAT",
        "5": "CAT (Online Only)",
        "8": "CAT",
        "16": "DIGITAL NATIONAL CAT WITH FEATURE (HELEN) & ETHNIC BUS STOPS",
        "17": "ETHNIC BUS STOPS",
        "18": "CAT",
        "21": "CAT ONLINE ONLY",
        "22": "NAV BEACON",
        "23": "NAV BEACON",
        "40": "CAT",
        "47": "CAT",
        "50": "CAT",
        "52": "CAT"
      },
      "SCAN DEAL": {
        "1": "0.74",
        "4": "0.9",
        "5": "0.83",
        "8": "0.9",
        "12": "0.74",
        "13": "0.48",
        "14": "0.74",
        "15": "0.48",
        "16": "0.9",
        "17": "0.48",
        "18": "0.74",
        "21": "0.83",
        "22": "0.83",
        "23": "0.74",
        "25": "0.74",
        "26": "0.74",
        "29": "0.74",
        "31": "0.9",
        "33": "0.74",
        "34": "0.48",
        "35": "0.9",
        "36": "0.48",
        "37": "0.74",
        "40": "0.9",
        "41": "0.48",
        "42": "0.74",
        "44": "0.74",
        "45": "0.71",
        "47": "0.9",
        "48": "0.48",
        "49": "0.48",
        "50": "0.9",
        "51": "0.48",
        "52": "0.9"
      },
      "ACTIVATION": {
        "4": "FGE008 (813 Stores)",
        "8": "FGE009 (639 Stores)",
        "12": "DWL001&DWL004",
        "13": "DWL001&DWL004",
        "14": "DWL001&DWL004",
        "15": "DWL001&DWL004",
        "16": "OGE012 (58 Stores) &DWL001&DWL004",
        "17": "DWL001&DWL004",
        "18": "GPL005&NBH007&NPG007",
        "25": "FGE011 (264 Stores)",
        "26": "FGE011 (264 Stores)",
        "29": "FGE011 (264 Stores)",
        "31": "NBH002, NPG002, OTG002",
        "32": "HOL005",
        "33": "HOL005",
        "34": "HOL005",
        "35": "OGE008 (566 Stores)",
        "40": "FGE005 (1000 Stores)",
        "44": "ISP-001, OTG-002 (Metro Only)",
        "47": "OGE002 (993 Stores) & BIN009 (115 Stores)",
        "48": "BIN009 (115 Stores)",
        "49": "BIN009 (115 Stores)",
        "50": "OGE010 (227 Stores) & BIN009 (115 Stores)",
        "51": "BIN009 (115 Stores)",
        "52": "BIN009 (115 Stores)"
      }
    }
  },
  {
    "assortment": "Infuzions 90g",
    "brand": "Infuzions",
    "data": {
      "PROMO PRICE": {
        "1": "50%OFF",
        "4": "2.95",
        "6": "2.95",
        "10": "2.95",
        "12": "50%OFF",
        "14": "2.95",
        "16": "2.95",
        "18": "50%OFF",
        "20": "2.95",
        "22": "50%OFF",
        "25": "2 FOR $7",
        "26": "2 FOR $7",
        "28": "50%OFF",
        "30": "2 FOR $7",
        "31": "2 FOR $7",
        "33": "2.95",
        "35": "50%OFF",
        "37": "2.95",
        "39": "2.95",
        "40": "2 FOR $7",
        "42": "50%OFF",
        "45": "50%OFF",
        "48": "2.95",
        "50": "2.95"
      },
      "PROMO/MEDIA": {
        "1": "CAT",
        "12": "CAT",
        "18": "CAT",
        "28": "CAT",
        "45": "CAT"
      },
      "SCAN DEAL": {
        "1": "1.09",
        "4": "0.64",
        "6": "0.64",
        "10": "0.74",
        "12": "1.15",
        "14": "0.74",
        "16": "0.74",
        "18": "1.15",
        "20": "0.74",
        "22": "1.15",
        "25": "0.6",
        "26": "0.6",
        "28": "1.15",
        "30": "0.6",
        "31": "0.6",
        "33": "0.74",
        "35": "1.15",
        "37": "0.74",
        "39": "0.74",
        "40": "0.6",
        "42": "1.15",
        "44": "0.6",
        "45": "1.15",
        "48": "0.74",
        "50": "0.74"
      },
      "ACTIVATION": {
        "1": "FGE012 (132 Stores)",
        "12": "OGE005 (950 Stores)",
        "18": "OGE007 (805 Stores)",
        "28": "OGE005 (950 Stores)",
        "35": "FGE010 (432 Stores)",
        "42": "OGE007 (709 Stores)",
        "45": "NBH-009, NPG-009 (Metro Only)"
      }
    }
  },
  {
    "assortment": "Infuzions Multi 5x15g",
    "brand": "Infuzions",
    "data": {
      "PROMO PRICE": {
        "1": "2 FOR $7",
        "2": "2 FOR $7",
        "3": "2 FOR $7",
        "4": "2 FOR $7",
        "5": "2 FOR $7",
        "6": "2 FOR $7",
        "7": "2 FOR $7",
        "8": "2 FOR $7",
        "9": "2 FOR $7",
        "10": "2 FOR $7",
        "11": "2 FOR $7",
        "12": "2 FOR $7",
        "13": "2 FOR $7",
        "14": "2 FOR $7",
        "15": "2 FOR $7",
        "16": "2 FOR $7",
        "17": "2 FOR $7",
        "18": "2 FOR $7",
        "19": "2 FOR $7",
        "20": "2 FOR $7",
        "21": "2 FOR $7",
        "22": "2 FOR $7",
        "23": "2 FOR $7",
        "24": "2 FOR $7",
        "25": "2 FOR $7",
        "26": "2 FOR $7",
        "27": "2 FOR $7",
        "28": "2 FOR $7",
        "29": "2 FOR $7",
        "30": "2 FOR $7",
        "31": "2 FOR $7",
        "32": "2 FOR $7",
        "33": "2 FOR $7",
        "34": "2 FOR $7",
        "35": "2 FOR $7",
        "36": "2 FOR $7",
        "37": "2 FOR $7",
        "38": "2 FOR $7",
        "39": "2 FOR $7",
        "40": "2 FOR $7",
        "41": "2 FOR $7",
        "42": "2 FOR $7",
        "43": "2 FOR $7",
        "44": "2 FOR $7",
        "45": "2 FOR $7",
        "46": "2 FOR $7",
        "47": "2 FOR $7",
        "48": "2 FOR $7",
        "49": "2 FOR $7",
        "50": "2 FOR $7",
        "51": "2 FOR $7",
        "52": "2 FOR $7"
      },
      "PROMO/MEDIA": {
        "3": "BTS REWARDS x10",
        "4": "BTS REWARDS x10",
        "49": "CAT"
      },
      "SCAN DEAL": {
        "1": "0.28",
        "2": "0.28",
        "3": "0.28",
        "4": "0.28",
        "5": "0.28",
        "6": "0.28",
        "7": "0.28",
        "8": "0.28",
        "9": "0.28",
        "10": "0.28",
        "11": "0.28",
        "12": "0.28",
        "13": "0.28",
        "14": "0.28",
        "15": "0.28",
        "16": "0.28",
        "17": "0.28",
        "18": "0.28",
        "19": "0.28",
        "20": "0.28",
        "21": "0.28",
        "22": "0.28",
        "23": "0.28",
        "24": "0.28",
        "25": "0.28",
        "26": "0.28",
        "27": "0.28",
        "28": "0.28",
        "29": "0.28",
        "30": "0.28",
        "31": "0.28",
        "32": "0.28",
        "33": "0.28",
        "34": "0.28",
        "35": "0.28",
        "36": "0.28",
        "37": "0.28",
        "38": "0.28",
        "39": "0.28",
        "40": "0.28",
        "41": "0.28",
        "42": "0.28",
        "43": "0.28",
        "44": "0.28",
        "45": "0.28",
        "46": "0.28",
        "47": "0.28",
        "48": "0.28",
        "49": "0.28",
        "50": "0.28",
        "51": "0.28",
        "52": "0.28"
      },
      "ACTIVATION": {
        "1": "SGE006 (Metro End)",
        "2": "SGE006 (Metro End)",
        "4": "SGE006 (Metro End)",
        "8": "DISPLAY",
        "10": "DISPLAY",
        "30": "MEB004 (735 Stores) - Bluey Only?",
        "31": "MEB004 (735 Stores) - Bluey Only?",
        "32": "MEB004 (735 Stores) - Bluey Only?",
        "40": "BLUEY NAV BEACON",
        "41": "BLUEY NAV BEACON",
        "42": "NBH-008, NPG-008 (Metro Only)",
        "43": "NBH-008, NPG-008 (Metro Only)",
        "45": "OLP001 (483 Stores)",
        "46": "OLP001 (483 Stores)"
      }
    }
  },
  {
    "assortment": "Bhuja 350g",
    "brand": "Bhuja",
    "data": {
      "PROMO PRICE": {
        "1": "$5.75 LOW PRICE",
        "2": "$5.75 LOW PRICE",
        "3": "$5.75 LOW PRICE",
        "4": "$5.75 LOW PRICE",
        "5": "$5.75 LOW PRICE",
        "6": "$5.75 LOW PRICE",
        "7": "$5.75 LOW PRICE",
        "8": "$5.75 LOW PRICE",
        "9": "$5.75 LOW PRICE",
        "10": "$5.75 LOW PRICE",
        "11": "$5.75 LOW PRICE",
        "12": "$5.75 LOW PRICE",
        "13": "$5.75 LOW PRICE",
        "14": "$5.75 LOW PRICE",
        "15": "$5.75 LOW PRICE",
        "16": "$5.75 LOW PRICE",
        "17": "$5.75 LOW PRICE",
        "18": "$5.75 LOW PRICE",
        "19": "$5.75 LOW PRICE",
        "20": "$5.75 LOW PRICE",
        "21": "$5.75 LOW PRICE",
        "22": "$5.75 LOW PRICE",
        "23": "$5.75 LOW PRICE",
        "24": "$5.75 LOW PRICE",
        "25": "$5.75 LOW PRICE",
        "26": "$5.75 LOW PRICE",
        "27": "$5.75 LOW PRICE",
        "28": "$5.75 LOW PRICE",
        "29": "$5.75 LOW PRICE",
        "30": "$5.75 LOW PRICE",
        "31": "$5.75 LOW PRICE",
        "32": "$5.75 LOW PRICE",
        "33": "$5.75 LOW PRICE",
        "34": "$5.75 LOW PRICE",
        "35": "$5.75 LOW PRICE",
        "36": "$5.75 LOW PRICE",
        "37": "$5.75 LOW PRICE",
        "38": "$5.75 LOW PRICE",
        "39": "$5.75 LOW PRICE",
        "40": "$5.75 LOW PRICE",
        "41": "$5.75 LOW PRICE",
        "42": "$5.75 LOW PRICE",
        "43": "$5.75 LOW PRICE",
        "44": "$5.75 LOW PRICE",
        "45": "$5.75 LOW PRICE",
        "46": "$5.75 LOW PRICE",
        "47": "$5.75 LOW PRICE",
        "48": "$5.75 LOW PRICE",
        "49": "$5.75 LOW PRICE",
        "50": "$5.75 LOW PRICE",
        "51": "$5.75 LOW PRICE",
        "52": "$5.75 LOW PRICE"
      },
      "ACTIVATION": {
        "12": "DWL004",
        "13": "DWL004",
        "14": "DWL004",
        "15": "DWL004",
        "16": "DWL004",
        "27": "REBOO5 (137 Stores)",
        "28": "REBOO5 (137 Stores)",
        "29": "REBOO5 (137 Stores)",
        "30": "REBOO5 (137 Stores)"
      }
    }
  },
  {
    "assortment": "Infuzions Air Fries 90g",
    "brand": "Infuzions Air Fries",
    "data": {
      "PROMO PRICE": {
        "1": "3.9",
        "4": "50%OFF",
        "6": "3.9",
        "9": "3.9",
        "11": "3.9",
        "13": "50%OFF",
        "15": "3.9",
        "17": "3.9",
        "19": "3.9",
        "21": "50%OFF",
        "25": "3.9",
        "26": "3.9",
        "29": "50%OFF",
        "31": "3.9",
        "34": "3.9",
        "37": "50%OFF",
        "41": "3.9",
        "44": "50%OFF",
        "47": "3.9",
        "50": "3.9"
      },
      "PROMO/MEDIA": {
        "4": "CAT",
        "13": "CAT",
        "21": "CAT"
      },
      "SCAN DEAL": {
        "1": "0.65",
        "4": "1.2",
        "6": "0.65",
        "9": "0.65",
        "11": "0.65",
        "13": "1.2",
        "15": "0.65",
        "17": "0.65",
        "19": "0.65",
        "21": "1.2",
        "25": "0.65",
        "26": "0.65",
        "29": "1.2",
        "31": "0.65",
        "34": "0.65",
        "37": "1.2",
        "41": "0.65",
        "44": "1.2",
        "47": "0.65",
        "50": "0.65"
      }
    }
  },
  {
    "assortment": "Infuzions Air Fries Multipacks 75g",
    "brand": "Infuzions Air Fries",
    "data": {
      "PROMO PRICE": {
        "16": "POG LANDING THIS WEEK",
        "19": "2 FOR $8",
        "20": "2 FOR $8",
        "21": "2 FOR $8",
        "22": "3.15",
        "23": "3.15",
        "25": "2 FOR $8",
        "26": "2 FOR $8",
        "27": "2 FOR $8",
        "28": "2 FOR $8",
        "29": "2 FOR $8",
        "30": "3.15",
        "31": "3.15",
        "32": "2 FOR $8",
        "33": "2 FOR $8",
        "36": "2 FOR $8",
        "37": "2 FOR $8",
        "38": "2 FOR $8",
        "39": "2 FOR $8",
        "42": "3.15",
        "43": "3.15",
        "44": "2 FOR $8",
        "45": "2 FOR $8",
        "46": "2 FOR $8",
        "47": "2 FOR $8",
        "48": "2 FOR $8",
        "49": "2 FOR $8",
        "50": "2 FOR $8",
        "51": "2 FOR $8"
      },
      "SCAN DEAL": {
        "19": "0.25",
        "20": "0.25",
        "21": "0.25",
        "22": "0.62",
        "23": "0.62",
        "25": "0.25",
        "26": "0.25",
        "27": "0.25",
        "28": "0.25",
        "29": "0.25",
        "30": "0.62",
        "31": "0.62",
        "32": "0.25",
        "33": "0.25",
        "36": "0.25",
        "37": "0.25",
        "38": "0.25",
        "39": "0.25",
        "42": "0.62",
        "43": "0.62",
        "44": "0.25",
        "45": "0.25",
        "46": "0.25",
        "47": "0.25",
        "48": "0.25",
        "49": "0.25",
        "50": "0.25",
        "51": "0.25"
      },
      "ACTIVATION": {
        "42": "AISLE FIN / DIG SCREEN",
        "43": "AISLE FIN"
      }
    }
  }
];

export const COLES_FY26_PROMOS = [
  {
    "assortment": "Bhuja 140-160g",
    "brand": "Bhuja",
    "data": {
      "PROMO PRICE": {
        "1": "3",
        "3": "50%OFF",
        "5": "3",
        "7": "2 FOR $6",
        "8": "2 FOR $6",
        "10": "3",
        "12": "50%OFF",
        "14": "3",
        "17": "3",
        "20": "50%OFF",
        "21": "4 FOR $10",
        "22": "4 FOR $10",
        "23": "3",
        "24": "3",
        "27": "50%OFF",
        "29": "2 FOR $6",
        "31": "3",
        "33": "2.95",
        "34": "2 FOR $6",
        "36": "50%OFF",
        "38": "2.95",
        "42": "2 FOR $6",
        "43": "50%OFF",
        "46": "50%OFF",
        "49": "2.95",
        "51": "50%OFF"
      },
      "PROMO/MEDIA": {
        "1": "CAT",
        "3": "CAT",
        "5": "CAT",
        "10": "CAT",
        "12": "CAT",
        "17": "CAT",
        "20": "CAT",
        "21": "ONLINE ONLY",
        "22": "ONLINE ONLY",
        "23": "CAT",
        "24": "CAT",
        "27": "CAT",
        "36": "CAT",
        "38": "CAT",
        "42": "CAT",
        "46": "CAT"
      },
      "SCAN DEAL": {
        "1": "0.58",
        "3": "1.04",
        "5": "0.58",
        "7": "0.6",
        "8": "0.6",
        "10": "0.58",
        "12": "1.04",
        "14": "0.58",
        "17": "0.58",
        "20": "1.04",
        "21": "0.92",
        "22": "0.92",
        "23": "0.58",
        "24": "0.58",
        "27": "1.04",
        "29": "0.6",
        "31": "0.58",
        "33": "0.6",
        "34": "0.6",
        "36": "1.04",
        "38": "0.6",
        "42": "0.6",
        "43": "1.04",
        "46": "1.04",
        "49": "0.6",
        "51": "1.04"
      },
      "ACTIVATION": {
        "3": "END 15 (BULK/SHELVED)",
        "20": "END 18",
        "36": "END 10 (79 Stores) Bulk",
        "46": "END02 - BULK (588 Stores)"
      }
    }
  },
  {
    "assortment": "Infuzions 90g",
    "brand": "Infuzions",
    "data": {
      "PROMO PRICE": {
        "3": "50%OFF",
        "5": "3",
        "7": "3",
        "11": "50%OFF",
        "14": "2 FOR $6",
        "17": "2.95",
        "19": "50%OFF",
        "21": "2 FOR $6",
        "22": "50%OFF",
        "25": "2.95",
        "26": "2.95",
        "28": "50%OFF",
        "31": "2.95",
        "33": "2 FOR $6",
        "35": "3",
        "37": "3",
        "40": "50%OFF",
        "43": "3",
        "44": "3",
        "47": "2 FOR $6",
        "49": "50%OFF",
        "51": "2 FOR $6",
        "52": "2.95"
      },
      "PROMO/MEDIA": {
        "5": "CAT",
        "7": "CAT",
        "11": "CAT",
        "22": "CAT",
        "28": "CAT",
        "37": "CAT",
        "40": "CAT",
        "43": "CAT",
        "49": "CAT"
      },
      "SCAN DEAL": {
        "3": "1.01",
        "5": "0.68",
        "7": "0.68",
        "11": "1.06",
        "14": "0.8",
        "17": "0.8",
        "19": "1.06",
        "21": "0.8",
        "22": "1.06",
        "25": "0.8",
        "26": "0.8",
        "28": "1.06",
        "31": "0.8",
        "33": "0.8",
        "35": "0.78",
        "37": "0.78",
        "40": "1.06",
        "43": "0.78",
        "44": "0.78",
        "47": "0.8",
        "49": "1.06",
        "51": "0.8",
        "52": "0.8"
      }
    }
  },
  {
    "assortment": "Infuzions Multi 5x15g",
    "brand": "Infuzions",
    "data": {
      "PROMO PRICE": {
        "1": "2 FOR $7",
        "2": "2 FOR $7",
        "3": "2 FOR $7",
        "4": "2 FOR $7",
        "5": "2 FOR $7",
        "6": "2 FOR $7",
        "7": "2 FOR $7",
        "8": "2 FOR $7",
        "9": "2 FOR $7",
        "10": "2 FOR $7",
        "11": "2 FOR $7",
        "12": "2 FOR $7",
        "13": "2 FOR $7",
        "14": "2 FOR $7",
        "15": "2 FOR $7",
        "16": "2 FOR $7",
        "17": "2 FOR $7",
        "18": "2 FOR $7",
        "19": "2 FOR $7",
        "20": "2 FOR $7",
        "21": "2 FOR $7",
        "22": "2 FOR $7",
        "23": "2 FOR $7",
        "24": "2 FOR $7",
        "25": "2 FOR $7",
        "26": "2 FOR $7",
        "27": "2 FOR $7",
        "28": "2 FOR $7",
        "29": "2 FOR $7",
        "30": "2 FOR $7",
        "31": "2 FOR $7",
        "32": "2 FOR $7",
        "33": "2 FOR $7",
        "34": "2 FOR $7",
        "35": "2 FOR $7",
        "36": "2 FOR $7",
        "37": "2 FOR $7",
        "38": "2 FOR $7",
        "39": "2 FOR $7",
        "40": "2 FOR $7",
        "41": "2 FOR $7",
        "42": "2 FOR $7",
        "43": "2 FOR $7",
        "44": "2 FOR $7",
        "45": "2 FOR $7",
        "46": "2 FOR $7",
        "47": "2 FOR $7",
        "48": "2 FOR $7",
        "49": "2 FOR $7",
        "50": "2 FOR $7",
        "51": "2 FOR $7",
        "52": "2 FOR $7"
      },
      "PROMO/MEDIA": {
        "40": "CAT",
        "48": "CAT",
        "50": "CAT"
      },
      "SCAN DEAL": {
        "1": "0.25",
        "2": "0.25",
        "3": "0.25",
        "4": "0.25",
        "5": "0.25",
        "6": "0.25",
        "7": "0.25",
        "8": "0.25",
        "9": "0.25",
        "10": "0.25",
        "11": "0.25",
        "12": "0.25",
        "13": "0.25",
        "14": "0.25",
        "15": "0.25",
        "16": "0.25",
        "17": "0.25",
        "18": "0.25",
        "19": "0.25",
        "20": "0.25",
        "21": "0.25",
        "22": "0.25",
        "23": "0.25",
        "24": "0.25",
        "25": "0.25",
        "26": "0.25",
        "27": "0.25",
        "28": "0.25",
        "29": "0.25",
        "30": "0.25",
        "31": "0.25",
        "32": "0.25",
        "33": "0.25",
        "34": "0.25",
        "35": "0.25",
        "36": "0.25",
        "37": "0.25",
        "38": "0.25",
        "39": "0.25",
        "40": "0.25",
        "41": "0.25",
        "42": "0.25",
        "43": "0.25",
        "44": "0.25",
        "45": "0.25",
        "46": "0.25",
        "47": "0.25",
        "48": "0.25",
        "49": "0.25",
        "50": "0.25",
        "51": "0.25",
        "52": "0.25"
      }
    }
  },
  {
    "assortment": "Bhuja 350g",
    "brand": "Bhuja",
    "data": {}
  },
  {
    "assortment": "Bhuja 50g",
    "brand": "Bhuja",
    "data": {
      "PROMO PRICE": {
        "1": "$2.00 EDV",
        "2": "$2.00 EDV",
        "3": "$2.00 EDV",
        "4": "$2.00 EDV",
        "5": "$2.00 EDV",
        "6": "$2.00 EDV",
        "7": "$2.00 EDV",
        "8": "$2.00 EDV",
        "9": "$2.00 EDV",
        "10": "$2.00 EDV",
        "11": "$2.00 EDV",
        "12": "$2.00 EDV",
        "13": "$2.00 EDV",
        "14": "$2.00 EDV",
        "15": "$2.00 EDV",
        "16": "$2.00 EDV",
        "17": "$2.00 EDV",
        "18": "$2.00 EDV",
        "19": "$2.00 EDV"
      },
      "ACTIVATION": {
        "1": "TICKET",
        "2": "TICKET",
        "3": "TICKET",
        "4": "TICKET",
        "5": "TICKET",
        "6": "TICKET",
        "7": "TICKET",
        "8": "TICKET",
        "9": "TICKET",
        "10": "TICKET",
        "11": "TICKET",
        "12": "TICKET",
        "13": "TICKET",
        "14": "TICKET",
        "15": "TICKET",
        "16": "TICKET",
        "17": "TICKET",
        "18": "TICKET",
        "19": "TICKET"
      }
    }
  },
  {
    "assortment": "Infuzions Air Fries 90g",
    "brand": "Infuzions Air Fries",
    "data": {
      "PROMO PRICE": {
        "20": "50%OFF",
        "24": "3.9",
        "27": "50%OFF",
        "30": "3.9",
        "32": "3.9",
        "34": "3.9",
        "38": "50%OFF",
        "40": "3.9",
        "43": "3.9",
        "44": "3.9",
        "46": "50%OFF",
        "49": "3.9",
        "51": "3.9"
      },
      "PROMO/MEDIA": {
        "20": "CAT",
        "38": "CAT",
        "46": "CAT"
      },
      "SCAN DEAL": {
        "20": "1.21",
        "24": "0.49",
        "27": "1.21",
        "30": "0.49",
        "32": "0.49",
        "34": "0.49",
        "38": "1.21",
        "40": "0.49",
        "43": "0.49",
        "44": "0.49",
        "46": "1.21",
        "49": "0.49",
        "51": "0.49"
      }
    }
  }
];